/**
 * Whether this browser can produce a wallet connection at all. AppKit lists
 * injected providers (extensions, wallet-app browsers) and WalletConnect; the
 * former announce themselves via EIP-6963 or the legacy `window.ethereum`.
 * A browser with neither is most likely a plain mobile browser, where the
 * user is better off continuing where their wallet lives.
 */

const announced = new Set<string>();
let listening = false;

function listen() {
    if (listening || typeof window === 'undefined') return;
    listening = true;
    window.addEventListener('eip6963:announceProvider', (event) => {
        const detail = (event as CustomEvent<{ info?: { uuid?: string } }>)
            .detail;
        if (detail?.info?.uuid) announced.add(detail.info.uuid);
    });
    window.dispatchEvent(new Event('eip6963:requestProvider'));
}

export function hasInjectedWalletProvider(): boolean {
    if (typeof window === 'undefined') return false;
    listen();
    if (announced.size > 0) return true;
    return !!(window as { ethereum?: unknown }).ethereum;
}
